import { render, staticRenderFns } from "./cabinet-bind.vue?vue&type=template&id=bf80111e&scoped=true"
import script from "./cabinet-bind.vue?vue&type=script&lang=ts"
export * from "./cabinet-bind.vue?vue&type=script&lang=ts"
import style0 from "./cabinet-bind.vue?vue&type=style&index=0&id=bf80111e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf80111e",
  null
  
)

export default component.exports